import { StyledArrowLink, StyledContent, StyledTitle, StyledContact } from '@/components/styles'
import { ContentSection, ContactsMap, Consultation, InfoBlock } from '@/components'
import genLinkParams from '@/lib/generateLinkParams'
import { phones, email } from '@/lib/config'
import Icon from '@/assets/icons'
import Link from 'next/link'
import { useTranslation } from "react-i18next";

const ConsultTrigger = (props) => {
  const { t } = useTranslation("global");
  return <StyledArrowLink {...props}>{t('bookAppointment')}</StyledArrowLink>
}

export default function PromotionsPage(props) {
  const { t } = useTranslation("global");

  const [reviewsHref, reviewsAs] = genLinkParams({ type: 'reviews' })

  return <></>

  return (
    <StyledContent>
      <StyledContent.Container>
        <StyledContent.Columns>
          <StyledContent.ColumnSide>
            <StyledContent.Side>
              <StyledTitle size="large" mb="medium" as="h1">
                {t('contacts.title')}
              </StyledTitle>


              <StyledContent.SideInfo tabletHidden>
                <InfoBlock
                  title={t('contacts.contactManagement')}
                  desc={t('contacts.yourQuestions')}
                >
                  <Consultation render={ConsultTrigger} />
                </InfoBlock>
              </StyledContent.SideInfo>

            </StyledContent.Side>
          </StyledContent.ColumnSide>

          <StyledContent.ColumnMain>
            <StyledContent.Contacts>
              <Contacts icon="location-icon" title={t('contacts.addressTitle')}>
                <p>{t('contacts.address')}</p>
              </Contacts>

              <Contacts icon="time-icon" title={t('contacts.hoursTitle')}>
                {/* {groupedSchedule.map(([time, daysStr], ind) => (
                  <p key={ind}>
                    <b>{daysStr}:</b> {time}
                  </p>
                ))} */}
                <p>08:00 - 20:00</p>
              </Contacts>

              <Contacts icon="phone-icon" title={t('contacts.phonesTitle')}>
                {phones.map((phone, ind) => {
                  const { title, href } = phone
                  return (
                    <a key={ind} href={href}>
                      {title}
                    </a>
                  )
                })}
              </Contacts>

              <Contacts icon="email-icon" title="Email">
                <a href={email.href}>{email.title}</a>
              </Contacts>
            </StyledContent.Contacts>

            <ContentSection pt="none">
              <img src="/images/contacts-img.png" />
            </ContentSection>

            <ContentSection pt="none" title={t('contacts.contactUsTitle')}>
              <StyledContent.Html>
                <p>{t('contacts.contactUsText.text1')}{' '}
                  <a href="mailto:santecentr@gmail.com">santecentr@gmail.com</a>.
                </p>
                <p>
                  {t('contacts.contactUsText.text2')}{' '}
                  <Link as={reviewsAs} href={reviewsHref}>
                    <a>{t('contacts.contactUsText.text2Link')}</a>
                  </Link>
                  .
                </p>
                <p>
                  {t('contacts.contactUsText.text3')}{' '}
                  <a href="mailto:pr@sante.by">pr@sante.by</a>
                </p>
                <p>
                  {t('contacts.contactUsText.text4')}{' '}
                  <a href="mailto:hr@sante.by">hr@sante.by</a>
                </p>
              </StyledContent.Html>
            </ContentSection>

            <StyledContent.MainInfo tabletVisible>
              <InfoBlock
                title={t('contacts.contactManagement')}
                desc={t('contacts.yourQuestions')}
              >
                <Consultation render={ConsultTrigger} />
              </InfoBlock>

            </StyledContent.MainInfo>

          </StyledContent.ColumnMain>
        </StyledContent.Columns>
      </StyledContent.Container>
    </StyledContent>
  )
}

function Contacts(props) {
  const { icon, title, children } = props

  return (
    <StyledContact>
      <StyledContact.Icon>
        <Icon name={icon} />
      </StyledContact.Icon>

      <StyledContact.Content>
        <StyledContact.Title>{title}:</StyledContact.Title>
        <StyledContact.Desc>{children}</StyledContact.Desc>
      </StyledContact.Content>
    </StyledContact>
  )
}
